const PERMISSIONS = {
  CAN_SHOW: 'canShow',
  CAN_UPDATE: 'canUpdate',
  CAN_DESTROY: 'canDestroy',
};

const CUSTOM_PERMISSIONS = {
  CAN_SHOW_MEMBERSHIPS: 'can_show_memberships',
  CAN_MANAGE_MEMBERSHIPS: 'can_manage_memberships',

  CAN_SHOW_MEETINGS: 'can_show_meetings',
  CAN_MANAGE_MEETINGS: 'can_manage_meetings',

  CAN_MANAGE_INVITATIONS: 'can_manage_invitations',

  CAN_SHOW_FEEDBACK_CHAINS: 'can_show_feedback_chains',
  CAN_UPDATE_STATUS_FEEDBACK_CHAINS: 'can_update_status_feedback_chains',
  CAN_UPDATE_FEEDBACK_CHAINS: 'can_update_feedback_chains',
  CAN_DESTROY_FEEDBACK_CHAINS: 'can_destroy_feedback_chains',

  CAN_SHOW_CAPITAL_TABLE: 'can_show_capital_table',
  CAN_SHOW_DETAILED_CAPITAL_TABLE: 'can_show_detailed_capital_table',
  CAN_MANAGE_CAPITAL_TABLE: 'can_manage_capital_table',

  CAN_SHOW_EXECUTION: 'can_show_execution',

  CAN_SET_CURRENT_MVP: 'can_set_current_mvp',
  CAN_MANAGE_MVPS: 'can_manage_mvps',

  CAN_SHOW_BUSINESS_ACTIVITY: 'can_show_business_activity',
  CAN_MANAGE_BUSINESS_ACTIVITY: 'can_manage_business_activity',

  CAN_SHOW_METRICS: 'can_show_metrics',
  CAN_MANAGE_METRICS: 'can_manage_metrics',
};

const TOOLS = {
  STARTUP: 'STARTUP',
  STARTUP_MAIN: 'STARTUP_MAIN',
  MEMBERSHIPS: 'MEMBERSHIPS',
  MEETINGS: 'MEETINGS',
  FEEDBACK_CHAINS: 'FEEDBACK_CHAINS',
  BLOG: 'BLOG',

  CEO: 'CEO',
  IGCEO_BOARD: 'IGCEO_BOARD',
  GCEO_FINANCE: 'GCEO_FINANCE',
  INVITATIONS: 'INVITATIONS',
  CAPITAL_TABLE: 'CAPITAL_TABLE',

  BUSINESS: 'BUSINESS',
  BUSINESS_MAIN: 'BUSINESS_MAIN',
  BMC_BOARD: 'BMC_BOARD',
  BUSINESS_ACTIVITY: 'BUSINESS_ACTIVITY',

  CUSTOMER_RELATIONS: 'CUSTOMER_RELATION',
  MONETIZATION: 'MONETIZATION',

  INFRASTRUCTURE: 'INFRASTRUCTURE_STARTUP_SECTION',

  VALUE_PROPOSITION: 'VALUE_PROPOSITION',
  VALUE_PROPOSITION_MAIN: 'VALUE_PROPOSITION_MAIN',
  IGTASKS_BOARD: 'IGTASKS_BOARD',
  PM_FIT: 'PM_FIT',
  MVP: 'MVP',
  EXECUTION: 'EXECUTION',
  PITCH: 'PITCH',
};

/*

const STARTUP_SECTIONS = {
    CUSTOMER_RELATION: "Customer Relations",
    MONETIZATION: "Monetization",
    INFRASTRUCTURE: "Infrastructure"
};
*/

export { PERMISSIONS, CUSTOM_PERMISSIONS, TOOLS };
